/**
 * Check if at least one of the words in an comma separated list exists as expected
 * @param answer  The word to search for
 * @param expected  A comma separated list as an string
 * @returns
 */
function answerAsExpected(answerId: number, expected: number[] = []) {
  return expected.includes(answerId)
}

export default answerAsExpected
